import Rendable from "@/glxp/abstract/rendable"
import Shader from "@/glxp/utils/shader"
import Node from "@/glxp/abstract/node"

import GEOM from "@/glxp/geom/plane"
import ShaderManifest from "../shaderManifest"
import { vec2, vec3, mat4 } from 'gl-matrix'

let _NV = mat4.create()

class Mesh extends Rendable {
  constructor(scene, geom, shader, texture, section = "global") {
    super(scene)

    this.gl = scene.gl
    this.scene = scene
    this.geom = geom
    this.name = geom.name
    this.section = section

    this.node = new Node()
    this.shader = new Shader(ShaderManifest[shader])
    this.texture = texture
    this.active = true
    this.depthTest = true

    this.node.position  = vec3.clone(geom.translate)
    this.node.scale     = vec3.clone(geom.scale)
    this.node.rotation  = vec3.clone(geom.rotation)

    this.time = 0
    this.seed = (Math.random()/2) + .5

    this.hasNormal = true
    this.initBuffer({
      vertices: geom.vertices,
      uvs: geom.uvs,
      indices: geom.indices,
      normal: geom.normal,
    })

    this.initProgram(this.shader.vert, this.shader.frag)
    this.initVao()
    this.initMatrix()
    this.createUniforms()
  }

  createUniforms() {
    this.createUniform('uNMatrix', 'mat4')
    this.createUniform("uTexture", "texture")
    this.createUniform("uGrain", "texture")
    this.createUniform("uTime")
    this.createUniform("uSeed")
    this.createUniform("uGrainValue")
  }

  applyState() {
    let gl = this.gl
    this.scene.applyDefaultState()
  }

  preRender() {}

  render() {
    if (!this.active) {
      return
    }
    this.preRender()

    let gl = this.gl
    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()

    mat4.mul(_NV, this.scene.camera.getViewMatrix(), this.node.getMatrix())
    mat4.invert(_NV, _NV)
    mat4.transpose(_NV, _NV)
    this.bindUniform('uNMatrix', _NV)

    if (this.texture) {
      gl.activeTexture(gl.TEXTURE0)
      gl.bindTexture(
        gl.TEXTURE_2D,
        this.scene.textureLoader.getTexture(this.texture)
      )
      this.bindUniform("uTexture", 0)
    }

    gl.activeTexture(gl.TEXTURE1)
    gl.bindTexture(
      gl.TEXTURE_2D,
      this.scene.textureLoader.getTexture("Grain")
    )
    this.bindUniform('uGrain', 1)

    this.time += this.scene.dt/1000

    this.bindUniform('uGrainValue', this.scene.config.grain.value)
    this.bindUniform("uSeed", this.seed)
    this.bindUniform("uTime", this.time)
    this.bindMatrixUniforms(this.scene.camera)

    gl.drawElements(
      gl.TRIANGLES,
      this.geom.indices.length,
      gl.UNSIGNED_SHORT,
      0
    )
    gl.bindVertexArray(null)
  }
}

export default Mesh
